// Styles
import 'normalize.css';
import './assets/scss/base.scss';

// Components
import FontPreviewToolbar from './components/FontPreviewToolbar/FontPreviewToolbar';

export { FontPreviewToolbar };



// WEBPACK FOOTER //
// ./node_modules/myfonts-font-preview-toolbar/src/exportedComponents.js